import { defineComponent, computed } from 'vue';
import __vue_component__ from '../../../../../../../../ui/Tag/Tag.vue.js';

var script = defineComponent({
    name: 'OrderFulfilmentStatusTags',
    components: {
        Tag: __vue_component__,
    },
    props: {
        statuses: {
            type: Array,
            required: true,
        },
        tagInfoGetter: {
            type: Function,
            required: true,
        },
    },
    setup(props) {
        const subset = computed(() => { var _a, _b; return (_b = (_a = props.statuses) === null || _a === void 0 ? void 0 : _a.slice(0, 2).map(({ status }) => status)) !== null && _b !== void 0 ? _b : []; });
        const remaining = computed(() => { var _a, _b, _c, _d; return ((_b = (_a = props.statuses) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0) - ((_d = (_c = subset.value) === null || _c === void 0 ? void 0 : _c.length) !== null && _d !== void 0 ? _d : 0); });
        const getTagStyle = (status) => props.tagInfoGetter(status).tagStyle;
        const getTagText = (status) => props.tagInfoGetter(status).text;
        return {
            subset,
            remaining,
            getTagStyle,
            getTagText,
        };
    },
});

export { script as default };
